module.exports = __webpack_public_path__ + "media/images/flags/ml-0ac683aa3b1d1054519b7bb07ea4713b.svg";